<template>
  <el-dialog
    v-model="dialogFormVisible"
    style="height: 594px; width: 547px"
    :before-close="handleClose"
    append-to-body
  >
    <div class="diatitle">免费试用</div>
    <div class="diatext">提交申请后会有工作人员和您联系，为您搭建试用程序</div>
    <el-form :model="form" class="formbox" ref="ruleFormRef" :rules="rules">
      <el-form-item label="" prop="name">
        <el-input
          v-model="form.name"
          autocomplete="off"
          placeholder="请输入您的称呼"
        />
      </el-form-item>
      <el-form-item label="" prop="address">
        <el-cascader
          v-model="address"
          :props="props1"
          :options="options1"
          clearable
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="" prop="phone">
        <el-input
          v-model="form.phone"
          autocomplete="off"
          placeholder="请输入手机号码（必填）*"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <div class="btnsure" @click="submitForm(ruleFormRef)">确认申请</div>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import axios from "axios";
import { ElMessage } from "element-plus";
import { reactive, ref, defineProps, onMounted, defineEmits } from "vue";
const props = defineProps(["showdialogFormVisible"]);
const dialogFormVisible = ref(false);
const props1 = {
  value: "id",
  label: "title",
  expandTrigger: "hover",
};
const address = ref([]);
const options1 = ref([]);
axios
  .request({
    url: "/api/gym-system/region/lazy-tree?type=city",
    method: "get",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Authorization: "Basic Z3ltOmd5bV9zZWNyZXQ=",
    },
  })
  .then((res) => {
    options1.value = res.data.data;
  });
onMounted(() => {
  dialogFormVisible.value = props.showdialogFormVisible;
});
const phoneNum = (rule, value, callback) => {
  let flag = /^1[0-9]{10}$/;
  if (value === "") {
    callback(new Error("请输入手机号码"));
  } else if (value && !flag.test(value)) {
    callback(new Error("手机号格式错误"));
  } else {
    callback();
  }
};

const rules = reactive({
  phone: [{ validator: phoneNum, trigger: "blur" }],
});
const form = reactive({
  name: "",
  phone: "",
  cityCode: "",
});

const ruleFormRef = ref();
const closeBox = defineEmits(["closeBox"]);
const handleClose = (done) => {
  closeBox("closeBox", false);
  done();
};
const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      form.cityCode = address.value ? address.value.join(",") : "";
      axios
        .request({
          url: "/api/gym-crm/trialuser/save",
          method: "post",
          data: { ...form },
          headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Basic Z3ltOmd5bV9zZWNyZXQ=",
          },
        })
        .then((res) => {
          ElMessage({
            message: "提交成功！",
            type: "success",
          });
          dialogFormVisible.value = false;
          closeBox("closeBox", false);
        });
    } else {
      console.log("error submit!", fields);
    }
  });
};
</script>
<style lang="scss">
.diatitle {
  width: 100%;
  text-align: center;
  font-size: 36px;
  font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
  font-weight: 500;
  color: #292829;
}

.diatext {
  width: 100%;
  text-align: center;
  font-size: 18px;
  font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
  font-weight: 400;
  color: #333333;
  margin: 21px auto 44px;
}

.formbox {
  .el-form-item {
    width: 477px;
    height: 71px;
    margin: 0px auto 13px;

    .el-input,
    .el-select {
      width: 100%;
      height: 100%;
    }

    .el-select .el-input.is-focus .el-input__wrapper,
    .el-select .el-input__wrapper.is-focus {
      box-shadow: none !important;
    }

    .el-input__wrapper {
      height: 71px;
      border-radius: 10px 10px 10px 10px;
      border: 1px solid rgba(153, 153, 153, 0.76);
      box-shadow: none !important;
      font-size: 18px;
    }
  }
}

.btnsure {
  width: 476px;
  height: 70px;
  background: #e50a33;
  border-radius: 10px 10px 10px 10px;
  opacity: 1;
  line-height: 70px;
  text-align: center;
  margin: auto;
  font-size: 22px;
  font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
  font-weight: 400;
  color: #f8f4f7;
}

.el-button--text {
  margin-right: 15px;
}

.el-select {
  width: 300px;
}

.el-input {
  width: 300px;
}

.dialog-footer button:first-child {
  margin-right: 10px;
}
</style>
